import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import './economyCalendar.scss';
import { DefaultBlot, EconomyCalendarImage } from 'src/assets';
import { useAnimatedView } from 'src/hooks/useAnimatedView';

export const EconomyCalendar = () => {
  const { t } = useTranslation();

  const ref = useRef();
  const { isVisible } = useAnimatedView(ref);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-events.js';
    script.async = true;

    script.innerHTML = JSON.stringify({
      width: '100%',
      height: '486px',
      colorTheme: 'light',
      isTransparent: false,
      locale: 'en',
      importanceFilter: '-1,0,1',
      countryFilter: 'ar,au,br,ca,cn,fr,de,in,id,it,jp,kr,mx,ru,sa,za,tr,gb,us,eu',
    });

    const container = document.getElementById('economy-calendar-widget-container');
    if (container) {
      container.appendChild(script);
    }
  }, []);

  return (
    <div className="economy-calendar">
      <div className={`economy-calendar-content ${isVisible ? 'active-animation' : ''}`} ref={ref}>
        <div className="economy-calendar-title">
          <supertitle>{t('economyCalendar:supertitle')}</supertitle>
          <h1>
            <blue-underline>{t('economyCalendar:economy')}</blue-underline>{' '}
            <blue-text>{t('economyCalendar:calendar')}</blue-text>
          </h1>
          <text className="economy-calendar-subtitle">{t('economyCalendar:subtitle')}</text>
        </div>
        <div className="economy-calendar-section">
          <div id="economy-calendar-widget-container" />
          <img
            src={EconomyCalendarImage}
            alt={EconomyCalendarImage}
            className="economy-calendar-image-1"
          />
        </div>
        <img src={DefaultBlot} alt={DefaultBlot} className="economy-calendar-image-2" />
      </div>
    </div>
  );
};
